import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

const SIMaintenanceSafety = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('General Maintenance Safety');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance</Breadcrumb.Item>
							<Breadcrumb.Item active>Maintenance Safety</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 maintenance-element">
								<Tab eventKey="General Maintenance Safety" title="General Maintenance Safety">
									<h2>GENERAL MAINTENANCE SAFETY PRECAUTIONS</h2>
									<p>When working around moving components, use caution as these devices could be activated without warning. Always lock out energy sources. Do not re-start the machinery until the entire system has been checked, all guards are in place, all gates closed and locked, and all personnel are informed of start-up!</p>
									<p>Maintenance Personnel should be familiar with equipment safety features prior to any maintenance action.</p>
									<p>Ensure that all power is removed and locked out prior to any maintenance action.</p>
									<div class="caution">
										<p>Before performing maintenance procedures, follow posted Lockout Procedures.</p>
									</div>
									<p>If any safety device tests fail, stop the system immediately, lockout the disconnect switch, and notify your supervisor to have the problem corrected.</p>
									<p>
										Before attempting any troubleshooting procedures, ensure machine is taken out of automatic mode at the <b>HMI</b>. Equipment left in automatic mode is dangerous, especially if the system stopped during an automatic sequence.
									</p>
									<p>When the equipment shuts down because of a fault, do not perform any maintenance until the equipment is first properly locked out.</p>
								</Tab>

								<Tab eventKey="Mechanical Maintenance Safety" title="Mechanical Maintenance Safety">
									<h2>MECHANICAL MAINTENANCE SAFETY PRECAUTIONS</h2>
									<p>Some general maintenance safety precautions are outlined below. The tables are intended as a guideline and should not replace maintenance safety standards derived in the plant.</p>
									<div class="warning">
										<p>Mechanical maintenance, adjustments, and repairs should be performed only by qualified technicians familiar with the system.</p>
									</div>
									<ul>
										<li>If mechanical service does not require the station to be powered up, disconnect and dissipate all energy sources and perform the appropriate lockout / tagout procedures.</li>
										<li>
											Maintenance work will not be performed until all hazardous energy sources to which employees may be exposed is controlled. Before proceeding with any equipment maintenance or repairs, verify that power is removed. Refer to the Verification Procedures outlined on the Lockout / Tagout (<b>LOTO</b>) placard to ensure energy source is controlled and start up of the energy source is not possible.
										</li>
										<li>Vertical or inclined sliding members should be properly blocked. Use of safety pins (where provided) to mechanically disable machine motions is highly required.</li>
										<li>All moving machinery components, as well as their surrounding areas should be kept free of tools, rags, dirt, and excessive oil.</li>
										<li>When guards are removed for repair work, they should be properly re-installed as soon as the work is completed. Prior to operating any machinery all protective guards and covers must be in position.</li>
										<li>For troubleshooting, it may be necessary to leave the power “ON”. Always be aware of hazardous energy sources.</li>
										<li>Keep all moving parts of machinery and surrounding areas free of tools, rags, dirt, and oil. Clean up oil spills immediately.</li>
										<li>Before operating any moving machinery after maintenance is performed, all protective guards must be in place, all panel doors are closed and secured, and all safety gates are closed and secured.</li>
									</ul>
								</Tab>

								<Tab eventKey="Electrical Maintenance Safety" title="Electrical Maintenance Safety">
									<h2>ELECTRICAL MAINTENANCE SAFETY PRECAUTIONS</h2>
									<div class="warning">
										<p>Electrical system maintenance should be performed only by qualified electrical technicians familiar with the system using the latest up-to-date electrical controls drawings.</p>
									</div>
									<ul>
										<li>A qualified electrician should be present when the electrical control panels are opened to perform checks and required repairs.</li>
										<li>Before performing maintenance or service on any part of the electrical system, perform all applicable lockout / tagout procedures. Before proceeding, verify that power is removed from all circuits.</li>
										<li>Maintenance work will not be performed until the hazardous energy to which employees may be exposed is controlled. This prevents the system from being powered on or restarted unexpectedly.</li>
										<li>A preliminary test should be conducted to confirm that no voltage is present before working on any circuit.</li>
										<li>Use only specified regulation fuses and never improvise for the replacement of fuses. Use approved fuse pullers when replacing the fuses.</li>
										<li>For troubleshooting, it may be necessary to leave the power “ON”. Always be aware of hazardous energy sources.</li>
										<li>Keep all moving parts of machinery and surrounding areas free of tools, rags, dirt, and oil. Clean up any spills immediately to prevent slip hazards.</li>
										<li>Before operating any moving machinery after maintenance is performed, all protective guards must be in place, all panel doors are closed and secured, and all safety gates are closed and secured.</li>
									</ul>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default SIMaintenanceSafety;
